import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import LoginPage from '@/pages/login/page';
import ForgotPasswordPage from '@/pages/esqueci-senha/page';
import CadastroPage from '@/pages/cadastro/page';
import AlterarSenhaPage from '@/pages/alterar-senha/page';
import ProtectedRoute from '@/components/layout/ProtectedRoute';
import AdminDashboard from '@/pages/admin/dashboard/page';
import AdminSolicitacoesEPI from '@/pages/admin/solicitacoes-epi/page';
import AdminIncidentes from '@/pages/admin/incidentes/page';
import AdminDenuncias from '@/pages/admin/denuncias/page';
import AdminUsuarios from '@/pages/admin/usuarios/page';
import AdminQuestionarios from '@/pages/admin/questionarios/page';
import AdminRelatorios from '@/pages/admin/relatorios/page';
import AdminConfiguracoes from '@/pages/admin/configuracoes/page';
import ColaboradorHome from '@/pages/colaborador/page';
import ColaboradorEPI from '@/pages/colaborador/epi/page';
import ColaboradorIncidente from '@/pages/colaborador/incidente/page';
import ColaboradorDenuncia from '@/pages/colaborador/denuncia/page';
import ColaboradorHistorico from '@/pages/colaborador/historico/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/esqueci-senha',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/cadastro',
    element: <CadastroPage />,
  },

  // Admin routes
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/solicitacoes-epi',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminSolicitacoesEPI />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/solicitações-epi',
    element: <Navigate to="/admin/solicitacoes-epi" replace />,
  },
  {
    path: '/admin/incidentes',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminIncidentes />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/denuncias',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminDenuncias />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/denúncias',
    element: <Navigate to="/admin/denuncias" replace />,
  },
  {
    path: '/admin/usuarios',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminUsuarios />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/usuários',
    element: <Navigate to="/admin/usuarios" replace />,
  },
  {
    path: '/admin/questionarios',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminQuestionarios />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/relatorios',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminRelatorios />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/configuracoes',
    element: (
      <ProtectedRoute requiredProfile="admin">
        <AdminConfiguracoes />
      </ProtectedRoute>
    ),
  },
  {
    path: '/alterar-senha',
    element: (
      <ProtectedRoute requiredProfile="any">
        <AlterarSenhaPage />
      </ProtectedRoute>
    ),
  },

  // Colaborador routes (any authenticated user can respond)
  {
    path: '/colaborador',
    element: (
      <ProtectedRoute requiredProfile="any">
        <ColaboradorHome />
      </ProtectedRoute>
    ),
  },
  {
    path: '/colaborador/epi',
    element: (
      <ProtectedRoute requiredProfile="any">
        <ColaboradorEPI />
      </ProtectedRoute>
    ),
  },
  {
    path: '/colaborador/incidente',
    element: (
      <ProtectedRoute requiredProfile="any">
        <ColaboradorIncidente />
      </ProtectedRoute>
    ),
  },
  {
    path: '/colaborador/denuncia',
    element: (
      <ProtectedRoute requiredProfile="any">
        <ColaboradorDenuncia />
      </ProtectedRoute>
    ),
  },
  {
    path: '/colaborador/historico',
    element: (
      <ProtectedRoute requiredProfile="any">
        <ColaboradorHistorico />
      </ProtectedRoute>
    ),
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
